import { formatISO, fromUnixTime, subDays } from 'date-fns'

export type DateWithStatus = {
  date: number
  status: 'blocked' | 'diet'
}

export type MealPlanDateStatus = 'blocked' | 'diet'

export const toMealPlanDateKey = (date: Date) => formatISO(date, { representation: 'date' })

export const getMealPlanDateStatuses = (
  datesWithStatus: DateWithStatus[] | undefined,
  daysLength: number,
): Map<string, MealPlanDateStatus> => {
  const result = new Map<string, MealPlanDateStatus>()
  const dietDates = (datesWithStatus ?? []).filter(({ status }) => status === 'diet')

  if (dietDates.length === 0) {
    return result
  }

  const lookbehindDays = Math.max(daysLength, 1) - 1

  for (const { date } of dietDates) {
    const dietDay = fromUnixTime(date)
    result.set(toMealPlanDateKey(dietDay), 'diet')

    for (let offset = 1; offset <= lookbehindDays; offset += 1) {
      const blockedKey = toMealPlanDateKey(subDays(dietDay, offset))
      if (result.get(blockedKey) === 'diet') {
        continue
      }
      result.set(blockedKey, 'blocked')
    }
  }

  return result
}
